module.exports = __webpack_public_path__ + "img/texture_dark.b186d6a6.jpg";